<template>
  <div class="massive-recommendations">
    <v-alert
      outlined
      dense
      class="recommendations-alert"
    >
      <div class="text-subtitle-2 font-weight-medium mb-2">
        <v-icon size="18" color="indigo darken-1" class="mr-1">mdi-lightbulb</v-icon>
        {{ $t('massive.recommendations.title') }}
      </div>
      <ul class="recommendations-list mb-0">
        <li v-if="isDelete" class="recommendation-item">
          <v-icon size="16" color="orange darken-1" class="mr-1">mdi-check</v-icon>
          {{ $t('massive.recommendations.deleteOnlySI') }}
        </li>
        <li v-if="isDelete" class="recommendation-item">
          <v-icon size="16" color="orange darken-1" class="mr-1">mdi-check</v-icon>
          {{ $t('massive.recommendations.deleteOmitted') }}
        </li>
        <li v-if="!isDelete" class="recommendation-item">
          <v-icon size="16" color="orange darken-1" class="mr-1">mdi-check</v-icon>
          {{ $t('massive.recommendations.roleOptional') }}
        </li>
      </ul>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'MassiveRecommendations',
  props: {
    isDelete: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="css" scoped>
.massive-recommendations {
  margin-bottom: 24px;
}

.recommendations-alert {
  background-color: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.12);
}

.recommendations-list {
  list-style: none;
  padding-left: 0;
}

.recommendation-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 14px;
  word-break: break-word;
  line-height: 1.5;
}

.recommendation-item:last-child {
  margin-bottom: 0;
}
</style>
